const ADJECTIVES = [
    'agile',
    'amber',
    'bold',
    'brave',
    'bright',
    'calm',
    'clever',
    'cosmic',
    'crisp',
    'eager',
    'fancy',
    'fleet',
    'gentle',
    'golden',
    'happy',
    'keen',
    'lively',
    'lucky',
    'mellow',
    'mighty',
    'noble',
    'polar',
    'proud',
    'quick',
    'quiet',
    'rapid',
    'silent',
    'solid',
    'sunny',
    'swift',
    'tidy',
    'vivid',
    'wild',
    'witty',
    'young',
    'zesty',
];

const NOUNS = [
    'aurora',
    'beacon',
    'breeze',
    'canyon',
    'comet',
    'coral',
    'crater',
    'delta',
    'dune',
    'ember',
    'falcon',
    'fjord',
    'galaxy',
    'glacier',
    'harbor',
    'heron',
    'island',
    'lagoon',
    'lotus',
    'meadow',
    'meteor',
    'nebula',
    'orbit',
    'otter',
    'panda',
    'pebble',
    'prairie',
    'quartz',
    'raven',
    'reef',
    'river',
    'sparrow',
    'summit',
    'tundra',
    'willow',
    'zephyr',
];

const pick = (list: string[]) => list[Math.floor(Math.random() * list.length)];

export function generateServiceName(): string {
    const suffix = Math.floor(Math.random() * 9000) + 1000;
    return `${pick(ADJECTIVES)}-${pick(NOUNS)}-${suffix}`;
}
